module.exports = __webpack_public_path__ + "img/首页-证书1.0256b662.jpg";